import { FileSanitizerService } from '@domain/json-file-importer';
import { ErrorCodes, FileModel } from '@shared';
import { LoggingService } from '@shared/logging';
import { IImportHandler } from '../import-handler.interface';

export class FileSanitizerHandler implements IImportHandler {
	private next: IImportHandler;

	public constructor(
		private fileSanitizerService: FileSanitizerService,
		private loggingService: LoggingService
	) {}

	public setNext(nextHandler: IImportHandler) {
		this.next = nextHandler;
	}

	public async handle(model: FileModel) {
		try {
			model = this.fileSanitizerService.keysValuesToLowerCase(model, ['column_name', 'primary_key']);
		} catch (error) {
			this.loggingService.error(ErrorCodes.FileSanitizerHandler, error);
			throw new Error('File sanize failure');
		}

		if (this.next) {
			await this.next.handle(model);
		}
	}
}
